import type {
    ClientResponse,
    ShippingMethod,
    ShippingMethodDraft,
    ShippingMethodUpdate,
    ShippingMethodUpdateAction,
} from '@commercetools/platform-sdk';

import type { ApiClientDetails } from '../../types';

export function shippingApi({ apiRoot }: ApiClientDetails) {
    async function getShippingMethodByKey(key: string): Promise<ShippingMethod> {
        return (await apiRoot().shippingMethods().withKey({ key }).get().execute()).body;
    }

    async function getShippingMethodsWhere(where?: string): Promise<ShippingMethod[]> {
        return (
            await apiRoot()
                .shippingMethods()
                .get({ queryArgs: { where, expand: 'zoneRates[*].zone' } })
                .execute()
        ).body.results;
    }

    async function createShippingMethod(shippingMethod: ShippingMethodDraft): Promise<ClientResponse<ShippingMethod>> {
        return await apiRoot().shippingMethods().post({ body: shippingMethod }).execute();
    }

    async function updateShippingMethod(
        { id, version }: ShippingMethod,
        actions: ShippingMethodUpdateAction[]
    ): Promise<ClientResponse<ShippingMethod>> {
        const body: ShippingMethodUpdate = { version, actions };
        return apiRoot().shippingMethods().withId({ ID: id }).post({ body }).execute();
    }

    return {
        getShippingMethodByKey,
        getShippingMethodsWhere,
        createShippingMethod,
        updateShippingMethod,
    };
}
